module.exports = __webpack_public_path__ + "img/pc-tips.7a146af4.svg";